(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((sectionRoot) => {
  document.querySelectorAll('[data-ae-video-carousel]').forEach((root) => {
    if (root.dataset.aeBound === 'true') return;
    root.dataset.aeBound = 'true';
    const viewport = root.querySelector('[data-ae-vc-viewport]');
    const track = root.querySelector('[data-ae-vc-track]');
    const slides = Array.from(track?.children || []);
    const prev = root.querySelector('[data-ae-vc-prev]');
    const next = root.querySelector('[data-ae-vc-next]');
    const progress = root.querySelector('[data-ae-vc-progress]');
    const modal = root.querySelector('[data-ae-vc-modal]');
    const modalVideo = modal?.querySelector('[data-ae-vc-modal-video]');
    const modalClose = modal?.querySelector('[data-ae-vc-modal-close]');
    const step = () => {
      const slide = slides[0];
      if (!slide) return viewport?.clientWidth || 1;
      const style = getComputedStyle(slide);
      return slide.getBoundingClientRect().width + parseFloat(style.paddingLeft || '0');
    };

    const update = () => {
      if (!viewport) return;
      const max = viewport.scrollWidth - viewport.clientWidth;
      const ratio = max <= 0 ? 1 : viewport.scrollLeft / max;
      if (progress) {
        progress.style.width = `${Math.min(100, Math.max(8, ratio * 100))}%`;
      }
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= max - 1;
    };

    prev?.addEventListener('click', () => {
      viewport?.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      viewport?.scrollBy({ left: step(), behavior: 'smooth' });
    });

    viewport?.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    const resetToStart = () => {
      if (!viewport) return;
      viewport.scrollLeft = 0;
      update();
    };
    [0, 50, 150, 350, 700].forEach((delay) => setTimeout(resetToStart, delay));
    window.addEventListener('pageshow', resetToStart);
    window.addEventListener('load', resetToStart);
    const openModal = (sourcesJson, poster) => {
      if (!modal || !modalVideo) return;
      let sources = [];
      try {
        sources = JSON.parse(sourcesJson || '[]');
      } catch (err) {
        sources = [];
      }

      modalVideo.innerHTML = '';
      modalVideo.removeAttribute('src');
      if (poster) modalVideo.setAttribute('poster', poster); else modalVideo.removeAttribute('poster');

      sources.forEach((src) => {
        if (!src || !src.url) return;
        const sourceEl = document.createElement('source');
        sourceEl.src = src.url;
        if (src.mime_type) sourceEl.type = src.mime_type;
        modalVideo.appendChild(sourceEl);
      });

      modalVideo.load();

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      const playPromise = modalVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          modalVideo.controls = true;
        });
      }
    };

    const closeModal = () => {
      if (!modal || !modalVideo) return;
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.innerHTML = '';
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };

    root.querySelectorAll('[data-ae-vc-card]').forEach((card) => {
      if (card.querySelector('.ae-video-carousel__preview')) {
        card.setAttribute('tabindex', '-1');
        return;
      }
      card.addEventListener('click', () => {
        const sources = card.getAttribute('data-video-sources');
        const poster = card.getAttribute('data-video-poster');
        if (!sources || sources === '[]') return;
        openModal(sources, poster);
      });
    });

    modalClose?.addEventListener('click', closeModal);

    modal?.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });

    modal?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeModal();
    });

    update();
  });
});
(function () {
  var vids = document.querySelectorAll('video.ae-video-carousel__preview[data-ae-vc-src]');
  if (!vids.length) return;
  var attach = function (v) {
    if (!v.src) { v.src = v.getAttribute('data-ae-vc-src'); v.removeAttribute('data-ae-vc-src'); }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  };
  if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { vids.forEach(attach); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { attach(v); }
      else if (v.src) { v.pause(); }
    });
  }, { rootMargin: '200px 0px' });
  vids.forEach(function (v) { io.observe(v); });
})();
